import GeneratedShareLinkServiceApi from "./generated/GeneratedShareLinkServiceApi"

class ShareLinkServiceApi extends GeneratedShareLinkServiceApi {

}

export const shareLinkServiceApi = new ShareLinkServiceApi()
